
export default function ComplianceSection() {
  const certifications = [
    {
      name: 'QCDD',
      description: 'Qatar Civil Defence Directorate Approved',
      icon: 'ri-shield-check-line',
      color: 'text-red-600 bg-red-50'
    },
    {
      name: 'ISO 9001',
      description: 'Quality Management System Certified',
      icon: 'ri-award-line',
      color: 'text-blue-600 bg-blue-50'
    },
    {
      name: 'NFPA 10',
      description: 'Standard for Portable Fire Extinguishers',
      icon: 'ri-file-shield-line',
      color: 'text-green-600 bg-green-50'
    },
    {
      name: 'BS EN 3',
      description: 'European Standard for Fire Extinguishers',
      icon: 'ri-checkbox-circle-line',
      color: 'text-purple-600 bg-purple-50'
    }
  ];

  const standards = [
    'Manufactured to international fire safety standards',
    'Regular quality control and testing procedures',
    'Compliant with Qatar building and fire codes',
    'Certified by recognized testing laboratories',
    'Meets environmental and safety regulations'
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Certifications & Compliance
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our dry chemical extinguishers meet the highest international standards and are approved by Qatar Civil Defence.
          </p>
        </div>

        {/* Certifications Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {certifications.map((cert, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
              <div className={`w-16 h-16 ${cert.color} rounded-full flex items-center justify-center mx-auto mb-4`}>
                <i className={`${cert.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{cert.name}</h3>
              <p className="text-sm text-gray-600">{cert.description}</p>
            </div>
          ))}
        </div>

        {/* Standards List */}
        <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8">
          <h3 className="text-xl font-semibold text-gray-900 mb-6 text-center">
            Quality Standards & Compliance
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {standards.map((standard, index) => (
              <div key={index} className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-green-600 text-sm"></i>
                </div>
                <p className="text-gray-700">{standard}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Compliance Note */}
        <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
          <div className="flex items-start space-x-3">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-information-line text-blue-600"></i>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-blue-900 mb-2">Compliance Assurance</h4>
              <p className="text-blue-800">
                All FlameGuardQA fire extinguishers are regularly tested and certified to ensure compliance with Qatar Civil Defence requirements and international fire safety standards. Our products undergo rigorous quality control processes and are backed by comprehensive warranties.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
